export const content = {
  en: {
    title: "Welcome to ICG GAMING",
    description: "Become an ICG Gaming partner and ready to launch your online casino business!",
    buttonText: "Contact Us",
    footerText: "Join Us On Telegram"
  },
  zh: {
    title: "欢迎来到ICG GAMING",
    description: "ICG GAMING顶级包网方案，拥有15年该领域经验，我们为您提供专业的一站式解决方案。让您的线上博彩业务快速上线、高效运作、灵活定制，助力您在市场中脱颖而出！",
    buttonText: "与我们联系",
    footerText: "加入我们的Telegram"
  }
};
